import { History } from '@orgus/ui/icons';
import type { SettingsSection } from '../registry.ts';
import { VersionsView } from '../../policy/VersionsView.tsx';

const section: SettingsSection = {
  id: 'policy-versions',
  title: 'Policy versions',
  description: 'Every change to rules, launch settings and freezes, with a way back.',
  order: 30,
  group: 'security',
  keywords: ['history', 'versions', 'rollback', 'undo', 'changes'],
  icon: History,
  Component: VersionsView,
  needs: { module: '/api/policy/versions', feature: 'Policy versions', plural: true, instead: 'Approval rules still apply as you set them in Settings, Approval rules.' },
};
export default section;
